// DiabeteSurveillanceBanner — Proposition automatique de la séance hebdomadaire
// de surveillance clinique (>75 ans, AMI 4) lorsqu'un soin lié au diabète est coché.
// Objectif : alerter les IDEL qui ignorent souvent cette cotation.

import { useState } from 'react';

interface DiabeteSurveillanceBannerProps {
  onAdd: () => void;
}

const CONDITIONS_ART_5BIS = [
  'Patient traité par insuline (insulinothérapie en cours)',
  'Patient âgé de plus de 75 ans',
  'Surveillance clinique de 30 minutes',
  'Cotation limitée à 1 fois par semaine (AMI 4)',
];

export default function DiabeteSurveillanceBanner({ onAdd }: DiabeteSurveillanceBannerProps) {
  const [showDetails, setShowDetails] = useState(false);

  return (
    <div className="rounded-xl border border-accent-200 bg-accent-50 px-4 py-3 animate-fadeIn">
      <div className="flex items-start gap-3">
        <div className="w-8 h-8 rounded-full bg-accent-100 flex items-center justify-center flex-shrink-0">
          <i className="ri-heart-pulse-line text-accent-600 text-sm"></i>
        </div>
        <div className="flex-1 min-w-0">
          <p className="text-xs font-bold text-accent-800">Séance hebdo. surveillance clinique — AMI 4</p>
          <p className="text-[10px] text-accent-600 mt-0.5 leading-relaxed">
            Patient diabétique de +75 ans : 30 min de surveillance clinique, cotée 1 fois par semaine. Souvent oubliée !
          </p>

          <div className="flex items-center gap-2 mt-2 flex-wrap">
            <button
              onClick={onAdd}
              className="px-3 py-1.5 rounded-lg text-[11px] font-bold bg-accent-500 text-white hover:bg-accent-600 transition-all cursor-pointer whitespace-nowrap"
            >
              Ajouter
            </button>
            <button
              onClick={() => setShowDetails((v) => !v)}
              className="px-3 py-1.5 rounded-lg text-[11px] font-semibold text-accent-700 bg-accent-100 hover:bg-accent-200 transition-all cursor-pointer whitespace-nowrap"
            >
              <i className={`ri-arrow-down-s-line ${showDetails ? 'rotate-180' : ''} transition-transform mr-1`}></i>
              En savoir plus
            </button>
          </div>

          {showDetails && (
            <div className="mt-3 pt-3 border-t border-accent-200/70 animate-fadeIn">
              <p className="text-[10px] font-bold text-accent-800 mb-2">Conditions Art. 5bis</p>
              <ul className="space-y-1.5">
                {CONDITIONS_ART_5BIS.map((condition) => (
                  <li key={condition} className="flex items-start gap-2 text-[10px] text-accent-700 leading-relaxed">
                    <i className="ri-checkbox-circle-line text-accent-500 text-xs mt-px flex-shrink-0"></i>
                    <span>{condition}</span>
                  </li>
                ))}
              </ul>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}